var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wow-file-upload uk-background-muted uk-padding uk-panel" },
    [
      _vm.value !== ""
        ? _c(
            "button",
            {
              ref: "remove",
              staticClass: "wow-file-upload__close-btn",
              attrs: { type: "button" },
              on: { click: _vm.onRemoveFile },
            },
            [_c("i", { staticClass: "mdi mdi-close" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.value === ""
        ? _c(
            "button",
            {
              ref: "buttom",
              staticClass:
                "uk-button uk-button-primary uk-align-center uk-margin-remove-bottom uk-position-center",
              attrs: { type: "button" },
              on: { click: _vm.onSelectFile },
            },
            [_c("span", { staticClass: "uk-text-small" }, [_vm._v("Browse")])]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.value !== ""
        ? _c("div", {
            staticClass: "wow-file-upload__preview",
            style: "background-image:url('" + _vm.value + "')",
            on: { click: _vm.onSelectFile },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        ref: "input",
        staticClass: "uk-hidden",
        attrs: { type: "file", "data-folder-name": _vm.folderName },
        on: { change: _vm.onChange },
      }),
      _vm._v(" "),
      _c("input", {
        ref: "text",
        staticClass: "uk-input uk-form-small uk-margin-remove",
        attrs: {
          "data-wow-attr": _vm.dataWowAttr,
          type: "hidden",
          placeholder: "Select file",
          disabled: "",
        },
        domProps: { value: _vm.value },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }